<template>
  <div class="error-box">
    <div class="row">
      <div class="col-sm-12 text-sm-center">
        <h1>500</h1>
        <h5>Ваш браузер не поддерживается</h5>
        <div class="alert alert-info">
          Просим Вас использовать интернет браузеры из списка:
          <p><strong>Chrome</strong></p>
          <p><strong>Safari</strong></p>
          <p><strong>Opera</strong></p>
        </div>
        <!--        <router-link class="btn btn-lg bg-yellow" to="/">-->
        <!--          <i class="icon-fa icon-fa-arrow-left"/> Go Home-->
        <!--        </router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.setLayoutClasses()
  },
  destroyed() {
    document.body.classList.remove('page-error-404')
  },
  methods: {
    setLayoutClasses() {
      let body = document.body
      body.classList.add('page-error-404')
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 5px;
}
</style>
